import { DictionariesListPage } from 'features/dictionaries/components/DictionariesListPage'
import { DictionaryType } from 'features/dictionaries/types'

export const DictionariesInventoryPage = () => {
  return <DictionariesListPage type={DictionaryType.Inventory} />
}
